module.exports = __webpack_public_path__ + "f26d8d0173e42f82e8ac85eb2363212f.svg";